import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Zap, Menu, X } from 'lucide-react';

const Header = ({ onNavigate }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const menuItems = [
    { label: 'Accueil', id: 'hero' },
    { label: 'Comment ça marche', id: 'how-it-works' },
    { label: 'Lieux', id: 'locations' },
    { label: 'Tarifs', id: 'pricing' },
    { label: 'Partenaires', id: 'partner' },
    { label: 'Contact', id: 'contact' }
  ];

  return (
    <header 
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-white/95 backdrop-blur-md shadow-md' 
          : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <button 
            onClick={() => onNavigate('hero')}
            className="flex items-center gap-2 group"
          >
            <div className="w-10 h-10 bg-yellow-500 rounded-lg flex items-center justify-center shadow-lg group-hover:shadow-xl transition-all duration-300 group-hover:scale-110">
              <Zap className="w-6 h-6 text-gray-900" />
            </div>
            <span className="text-2xl font-bold text-gray-900">JYA</span>
          </button>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            {menuItems.map((item) => (
              <button
                key={item.id}
                onClick={() => onNavigate(item.id)}
                className="text-gray-700 hover:text-yellow-600 font-medium transition-colors duration-200 relative group"
              >
                {item.label}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-yellow-500 group-hover:w-full transition-all duration-300" />
              </button>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:block">
            <Button 
              className="bg-yellow-500 hover:bg-yellow-600 text-gray-900 font-semibold px-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300"
              onClick={() => onNavigate('contact')}
            >
              Nous Contacter
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            {isMobileMenuOpen ? (
              <X className="w-6 h-6 text-gray-900" />
            ) : (
              <Menu className="w-6 h-6 text-gray-900" />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden mt-4 py-4 border-t border-gray-200 animate-fade-in">
            <nav className="flex flex-col gap-4">
              {menuItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => {
                    onNavigate(item.id);
                    setIsMobileMenuOpen(false);
                  }}
                  className="text-left text-gray-700 hover:text-yellow-600 font-medium py-2 px-4 hover:bg-yellow-50 rounded-lg transition-all duration-200"
                >
                  {item.label}
                </button>
              ))}
              <Button 
                className="bg-yellow-500 hover:bg-yellow-600 text-gray-900 font-semibold mt-2"
                onClick={() => {
                  onNavigate('contact');
                  setIsMobileMenuOpen(false);
                }}
              >
                Nous Contacter
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
